import type { FC } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import OriginalBrushGradient from '@wix/da-ds/pkg/Icons/24x24/OriginalBrushGradient';

interface Props {}

const CreateOriginalButton: FC<Props> = () => {
  const { t } = useTranslation();
  const dispatchPushModal = useAction(pushModal);

  const handleClick = useCallback(
    () =>
      dispatchPushModal(ModalType.ORIGINAL_DEVIATION, {
        wrapInModal: false,
      }),
    [dispatchPushModal]
  );

  return (
    <TextButton
      size="large"
      variant="main"
      priority="primary"
      icon={OriginalBrushGradient}
      onClick={handleClick}
    >
      {t('studio.products.originals.createButton')}
    </TextButton>
  );
};
CreateOriginalButton.displayName = 'CreateOriginalButton';

export default CreateOriginalButton;
